import { CacheTable } from './cache-table';

export class CacheFirebaseStorage extends CacheTable<string> {

  constructor() { super('storage_urls', 'performance'); }

}
